export enum LinkPreviewData_Styles_Position {
  /** START - Thumbnail positioned at the start (left in LTR layouts, right in RTL layouts) */
  START = "START",
  /** END - Thumbnail positioned at the end (right in LTR layouts, left in RTL layouts) */
  END = "END",
  /** TOP - Thumbnail positioned at the top */
  TOP = "TOP",
  /** HIDDEN - Thumbnail hidden and not displayed */
  HIDDEN = "HIDDEN",
  UNRECOGNIZED = "UNRECOGNIZED",
}